// client/src/components/landing/CTABandSection.js
// 하단 CTA 밴드 (v6 B안) — 가입 선택 페이지(/register)와 서비스 가이드로 연결
import React from 'react';
import { useNavigate } from 'react-router-dom';

function CTABandSection() {
  const nav = useNavigate();

  return (
    <section className="lnd-sec lnd-wrap" style={{ paddingTop: 8, paddingBottom: 72 }}>
      <div className="ctaband">
        <h2>가입은 3분이면 충분해요</h2>
        <p>역할을 고르면 필요한 것만 물어봐요 — 지금 시작해보세요.</p>
        <div className="row">
          <button type="button" className="lnd-btn lnd-btn--white lnd-btn--lg" onClick={() => nav('/register')}>
            셀프애드 시작하기
          </button>
          <button
            type="button"
            className="lnd-btn lnd-btn--glass lnd-btn--lg"
            onClick={() => window.open('/guide', '_blank', 'noopener,noreferrer')}
          >
            서비스 가이드 보기
          </button>
        </div>
      </div>
    </section>
  );
}

export default CTABandSection;
